import { call, put, select, take, takeLatest } from "@redux-saga/core/effects";
import actionTypes from "../../action/actionTypes";
import tryGetValidData from "../../../lib/middlewares/helpers/tryGetValidData";
import getUserAnswersSchema from "../../validation/getUserAnswersSchema";
import getPercentage from "../../../lib/functions/getPercentage";
import putError from "../../../lib/middlewares/helpers/putError";



function* getQuestionsResult(questId, answers, userResult, answersResults, resultsObj) {
    for (let a = 0; a < answersResults.length; a++) {
        const { answer, val } = answersResults[a]
        const { participant, resultItem } = answers[answer]
        const resultId = participant + '_' + resultItem
        const result = 4 - Math.abs(userResult - val)

        if(resultsObj.hasOwnProperty(resultId)) {
            resultsObj[resultId].result += result
            resultsObj[resultId].max += 4
            resultsObj[resultId].percent = getPercentage(resultsObj[resultId].result, resultsObj[resultId].max, false)
        } else {
            resultsObj[resultId] = {
                question: questId,
                resultItem: resultItem,
                participant: participant,
                result: result,
                max: 4,
                percent: getPercentage(result, 4, false)
            }
        }
    }
}

function* getResults({payload}) {
    try {
        const questions = yield select(state => state.questions)
        const answers = yield select(state => state.answers.items)

        const userAnswersSchema = yield call(getUserAnswersSchema)
        const userAnswers = yield call(tryGetValidData, userAnswersSchema, payload)

        const questionsMappings = yield select(state => state.questionsMappings.items)
        const questionsLength = yield questions.order.length 

        let resultsObj = yield {}


        for (let q = yield 0; yield q < questionsLength; yield q++) {
            const questId = yield questions.order[q]


            if(yield !userAnswers.userAnswers.hasOwnProperty(questId)) {
                throw new Error('Invalid user answer')
            }

            const userResult = yield userAnswers.userAnswers[questId]

            if(yield questionsMappings.hasOwnProperty(questId)) {
                const answersResults = yield questionsMappings[questId]

                yield call(getQuestionsResult, questId, answers, userResult, answersResults, resultsObj)
            }
        }

        const sortedResults = yield Object.values(resultsObj).sort((a, b) => b.percent - a.percent)

      

        if(!sortedResults || !sortedResults.length) {
            throw new Error('Es konnten keine Ergebnisse berechnet werden')
        }

        const slicedResults = sortedResults.length > 20 ? sortedResults.slice(0, 20)  : sortedResults

        yield put({
            type: actionTypes.MATRIX_RESULTS_SUCCES,
            payload: {
                results: slicedResults
            }
        })
    } catch(e) {
        yield call(putError, actionTypes.MATRIX_RESULTS_ERROR, e)
    }
}

export function* watchGetResults() {
    yield takeLatest(actionTypes.MATRIX_RESULTS_REQUEST, getResults)
}